import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=19e8749a&scoped=true&"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfiguration.vue?vue&type=style&index=0&id=19e8749a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e8749a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e8749a')) {
      api.createRecord('19e8749a', component.options)
    } else {
      api.reload('19e8749a', component.options)
    }
    module.hot.accept("./EmailConfiguration.vue?vue&type=template&id=19e8749a&scoped=true&", function () {
      api.rerender('19e8749a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/EmailConfiguration.vue"
export default component.exports